// src/api/encounterApi.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { serverApi, getAuthHeaders, handleApiResponse, handleReferenceResponse, queApi } from "@core/api/core"
import { PharmaItemSerializer as PharmaSimpleSerializer } from "@/types/pharma"
import { CommonReferenceResponse } from "@/types/common"

export const fetchPharmaSimple = createAsyncThunk<PharmaSimpleSerializer[], void, { rejectValue: string }>(
  "pharma/fetchPharmaSimple",
  async (_, { rejectWithValue }) => {
    try {
      const requestUrl = `/reference/pharma_simple/`
      const response = await queApi.get<CommonReferenceResponse>(requestUrl)

      const { columns, results } = handleReferenceResponse(response)

      if (!columns) {
        throw new Error("columns is undefined in pharma items response")
      }

      if (!results) {
        throw new Error("results is undefined in pharma items response")
      }

      const pharmaSimples: PharmaSimpleSerializer[] = (results as any[][]).map((row: any[]) => {
        // columns[i] ↔ row[i] 매핑
        const obj = Object.fromEntries(columns.map((col, i) => [col, row[i]])) as Record<string, any>

        return {
          id: Number(obj["id"]) || 0,
          pharmaProductCode: String(obj["pharmaProductCode"] || ""),
          pharmaProductName: String(obj["pharmaProductName"] || ""),
          pharmaCompany: String(obj["pharmaCompany"] || ""),
          pharmaMaxPrice: Number(obj["pharmaMaxPrice"]) || 0,
          pharmaGrossWeight: Number(obj["pharmaGrossWeight"]) || 0,
          pharmaDanwi: Number(obj["pharmaDanwi"]) || 0,
        }
      })
      return pharmaSimples
    } catch (error: any) {
      return rejectWithValue(error.message || "약품 정보 조회 중 오류가 발생했습니다.")
    }
  }
)
